import { Suspense, useState } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import GoToFirstJobButton from './GoToFirstJobButton';
import GoToLastJobButton from './GoToLastJobButton';
import GoToNextJobButton from './GoToNextJobButton';
import GoToNextJobButtonFallback from './GoToNextJobButton/GoToNextJobButtonFallback';
import GoToPrevJobButton from './GoToPrevJobButton';
import JobNavigator from './JobNavigator';
import ResetAnnotationsButton from './ResetAnnotationsButton';
import SaveJobButton from './SaveJobButton';

const Toolbar = (): JSX.Element => {
  const [editIndexMode, setEditIndexMode] = useState(false);

  return (
    <>
      <ResetAnnotationsButton />
      <GoToFirstJobButton editIndexMode={editIndexMode} />
      <GoToPrevJobButton editIndexMode={editIndexMode} />
      <JobNavigator
        editIndexMode={editIndexMode}
        setEditIndexMode={setEditIndexMode}
      />
      <Suspense fallback={<GoToNextJobButtonFallback />}>
        <ErrorBoundary fallback={<></>}>
          <GoToNextJobButton editIndexMode={editIndexMode} />
        </ErrorBoundary>
      </Suspense>
      <GoToLastJobButton editIndexMode={editIndexMode} />
      <ErrorBoundary fallback={<></>}>
        <SaveJobButton setEditIndexMode={setEditIndexMode} />
      </ErrorBoundary>
    </>
  );
};

export default Toolbar;
